import { useEffect, useRef, useState, useMemo } from "react";
import { useRecoilValue } from "recoil";
import { rodinInitWeightAtom, rodinUploadedImages, taskDetailAtom } from "../../../../store";
import { RODINWEIGHTS } from "../../../../utils/map";
import style from "../rodingenerateboard.module.css";
import { IoMdArrowDropleft } from "react-icons/io";
import { IoMdArrowDropright } from "react-icons/io";
import { Annotation } from './Annotation'
import { useTranslation } from "react-i18next";
import shipPng from '../assets/ship.png'
import DirectionSelector from "./directionSelector";
import { useThrottle } from "../../../../utils/hooks";

const WeightSelector = ({ disabled, viewWeights, pointerArr, setPointerArr, mode, setSelectedDirection, selectedDirection, setSelectorHover, dragging, setDragging }) => {
    const colorArr = ['linear-gradient(90deg,#8E7FFF 6.74%,#4737FF 57.91%)', 'linear-gradient(90deg,#F9C881 6.74%,#FF9737 57.91%)', 'linear-gradient(90deg,#FBFFA4 6.74%,#E9F648 57.91%)', 'linear-gradient(90deg,#489EF6 6.74%,#3787FF 57.91%)', 'linear-gradient(90deg,#CCA7FF 6.74%,#9B37FF 57.91%)', '#FFD337', '#FF3797'];
    const textColorArr = ['#4737FF', '#FF9737', '#D7FF37', '#3787FF', '#9B37FF', '#FFD337', '#FF3797'];
    const hoverColorArr = ['rgba(217, 214, 255, 1)', 'rgba(255, 227, 200, 1)', 'rgba(228, 255, 172, 1)', 'rgba(203, 224, 255, 1)', 'rgba(234, 213, 255, 1)'];
    const [currentLength, setCurrentLength] = useState(5);
    const controlerItemRefs = [useRef(null), useRef(null), useRef(null), useRef(null), useRef(null), useRef(null), useRef(null)];
    const uploadImgBlob = useRecoilValue(rodinUploadedImages);
    const rodinInitWeight = useRecoilValue(rodinInitWeightAtom);
    const leftControler = useRef(null);
    const rightControler = useRef(null);
    const weightTipRef = useRef(null)
    const [currentDefaultWeight, setCurrentDefaultWeight] = useState(rodinInitWeight)
    const controlerBoxRef = useRef(null)
    const maxPointer = useRef(null)
    const [currentIndex, setCurrentIndex] = useState(-1);
    const [weightTipIndex, setWeightTipIndex] = useState(true)
    const [weightsTipInit, setWeightsTipInit] = useState(false);
    const [viewWeightsInit, setViewWeightsInit] = useState(false);
    const [shipBg, setShipBg] = useState(false);
    const [currentWeight, setCurrentWeight] = useState(false)
    const [resizeInit, setResizeInit] = useState(false);
    const taskDetail = useRecoilValue(taskDetailAtom)
    const disabledStatus = ['Created', 'ModelGenerate'].includes(taskDetail?.step) && taskDetail?.settings?.condition_mode === 'concat'
    const { t } = useTranslation();
    const presetDirections = [null, "/assets/rodin/directions/0000.webp", "/assets/rodin/directions/0001.webp", "/assets/rodin/directions/0002.webp", "/assets/rodin/directions/0003.webp", "/assets/rodin/directions/0004.webp", "/assets/rodin/directions/0005.webp", "/assets/rodin/directions/0006.webp", "/assets/rodin/directions/0007.webp", "/assets/rodin/directions/0008.webp", "/assets/rodin/directions/0009.webp"]
    const directions = [t('RODIN_WEIGHT_UNKNOWN'), t('RODIN_WEIGHT_FRONT'), t('RODIN_WEIGHT_FRONT_LEFT'), t('RODIN_WEIGHT_LEFT'), t('RODIN_WEIGHT_BACK_LEFT'), t('RODIN_WEIGHT_BACK'), t('RODIN_WEIGHT_BACK_RIGHT'), t('RODIN_WEIGHT_RIGHT'), t('RODIN_WEIGHT_FRONT_RIGHT'), t('RODIN_WEIGHT_UP'), t('RODIN_WEIGHT_DOWN')];


    useEffect(() => {
        if (controlerBoxRef.current && viewWeights && !viewWeightsInit) {
            calculatePositionByWeight(viewWeights)
            setCurrentLength(viewWeights.length)
            setViewWeightsInit(true)
        }
    }, [controlerBoxRef.current, viewWeights])

    useEffect(() => {
        if (viewWeights && controlerBoxRef.current && !resizeInit) {
            window.addEventListener('resize', handlerUpdateControlerBoxSize)
            setResizeInit(true)
        }
    }, [viewWeights, controlerBoxRef.current])

    const handlerUpdateControlerBoxSize = () => {
        if (viewWeights && controlerBoxRef.current) {
            maxPointer.current = controlerBoxRef.current.clientWidth
            calculatePositionByWeight(viewWeights)
            setCurrentLength(viewWeights.length)
        }
    }

    useEffect(() => {
        if (controlerBoxRef.current) {
            maxPointer.current = controlerBoxRef.current.clientWidth
        }
    }, [controlerBoxRef.current])

    useEffect(()=>{
        if(weightTipIndex===true && currentLength > 0 && viewWeightsInit){
            if(weightTipRef.current){
                clearInterval(weightTipRef.current)
            }
            let index=0
            weightTipRef.current=setInterval(()=>{
                if(index===currentLength){
                    setWeightTipIndex(index)
                    index=0
                    
                }else{
                    setWeightTipIndex(index)
                    index++
                }
            },2000)
        }
    },[weightTipIndex, currentLength, viewWeightsInit])


    const calculatePositionByWeight = (weight) => {
        const maxPointer = controlerBoxRef.current.clientWidth
        let pointerArr = new Array(weight.length + 1)
        let sum = 1
        for (let i = weight.length; i >= 0; i--) {
            pointerArr[i] = maxPointer * sum
            if (sum > 0) {
                sum -= weight[i - 1]
            }
        }
        setPointerArr(pointerArr)
    }

    const handlerDefault = (e) => {
        let target = e.target;
        while (target !== null) {
            const customAttributeValue = target.getAttribute('data-name');
            if (customAttributeValue === 'widthBox') {
                let index = +target.getAttribute('data-index')
                if (viewWeights && [0, 1, 2].includes(index)) {
                    setCurrentDefaultWeight(index)
                    let WEIGHTS = RODINWEIGHTS[index][viewWeights.length - 1]
                    if (viewWeights.length > 5) {
                        WEIGHTS = RODINWEIGHTS[index][4]
                    }
                    calculatePositionByWeight(WEIGHTS)
                    return;
                }
            }
            target = target.parentElement; // 沿着父元素链继续查找
        }

    }

    const handlerClickWeight = (index) => {
        if (disabled || disabledStatus) return;
        setCurrentIndex(index);
    }

    const throttledMouseMove = useThrottle((e, startX, pointerIndex, copyPointer, newPointerArr, updateLogic) => {
        const endX = e.clientX;
        const diffX = endX - startX;
        updateLogic(diffX, pointerIndex, newPointerArr, copyPointer);
        setPointerArr(newPointerArr.slice());
    }, 10);

    const updateRightDrag = (diffX, pointerIndex, newPointerArr, copyPointer) => {
        newPointerArr[pointerIndex] = Math.min(copyPointer[pointerIndex] + diffX, maxPointer.current - (pointerArr.length - pointerIndex - 1) * 20);
        for (let i = pointerIndex + 1; i < pointerArr.length - 1; i++) {
            if (newPointerArr[i] < newPointerArr[i - 1] + 20) {
                newPointerArr[i] = newPointerArr[i - 1] + 20;
            } else {
                break;
            }
        }
    };

    const updateLeftDrag = (diffX, pointerIndex, newPointerArr, copyPointer) => {
        newPointerArr[pointerIndex] = Math.max(copyPointer[pointerIndex] + diffX, pointerIndex * 20);
        for (let i = pointerIndex - 1; i > 0; i--) {
            if (newPointerArr[i] > newPointerArr[i + 1] - 20) {
                newPointerArr[i] = newPointerArr[i + 1] - 20;
            } else {
                break;
            }
        }

        if (newPointerArr[pointerIndex] > copyPointer[pointerIndex + 1] - 20) {
            newPointerArr[pointerIndex] = copyPointer[pointerIndex + 1] - 20;
        }
    };


    const handlerLeftMouseDown = (event) => {
        if (disabled || event.button !== 0 || disabledStatus) return;
        if(!weightsTipInit){
            setWeightsTipInit(true)
            if(weightTipRef.current){
                clearInterval(weightTipRef.current)
            }
            setWeightTipIndex(false)
        }
        const startX = event.clientX;
        const pointerIndex = currentIndex;
        const newPointerArr = pointerArr.slice();
        const copyPointer = pointerArr.slice();
        document.onmousemove = (e) => throttledMouseMove(e, startX, pointerIndex, copyPointer, newPointerArr, updateLeftDrag);
        document.onmouseup = function () {
            document.onmousemove = null;
            document.onmouseup = null;
        };
        if (event.preventDefault) {
            event.preventDefault();
        }
    };

    const handlerRightMouseDown = (event) => {
        if (disabled || event.button !== 0 || disabledStatus) return;
        const startX = event.clientX;
        const pointerIndex = currentIndex + 1;
        const newPointerArr = pointerArr.slice();
        const copyPointer = pointerArr.slice();
        document.onmousemove = (e) => throttledMouseMove(e, startX, pointerIndex, copyPointer, newPointerArr, updateRightDrag);
        document.onmouseup = function () {
            document.onmousemove = null;
            document.onmouseup = null;
        };
        if (event.preventDefault) {
            event.preventDefault();
        }
    };

    const DefaultWidth = {
        0: <AverageWidthBoxes />,
        1: <DecreasingWidthBoxes />,
        2: <PrimaryWidthBoxes />
    }

    async function urlToBase64(url) {
      return fetch(url)
        .then((response) => response.blob())
        .then((blob) => {
          return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.onerror = reject;
            reader.readAsDataURL(blob);
          });
        });
    }

    useEffect(()=>{
        const changeImg = async () => {
            try {
              const [newShipPng] = await Promise.all([
                urlToBase64(shipPng)
              ]);
      
              setShipBg(newShipPng);
            } catch (error) {
              console.error("Error converting images:", error);
            }
          };
      
          changeImg();
    },[])

    const imagedoms = useMemo(() =>
        <img
        src={shipBg}
        alt="Selectable angle"
        className="w-full h-full"
        draggable="false"
    />
    , [shipBg]);

    return (
        <div id='rodinWeightBox' className={`${style.weightBox} ${viewWeights ? "" : style.loading} z-[2]`}>
            {!disabled && (
                <div className={style.weightTitle}>
                    <div className={style.subTitle}>
                        {mode === "fuse" && currentLength > 1
                            ? t('RODIN_GENERTAE_GEO_WEIGHT_DIRECTION')
                            : t('RODIN_GENERTAE_BOARD_GEO_DIRECTION')}
                        <Annotation
                            text={mode === "concat" ? t('RODIN_GENERTAE_BOARD_GEO_DIRECTION_EXEG') : t('RODIN_GENERTAE_BOARD_GEO_WEIGHT_EXEG')}
                            left={'-3rem'} />
                    </div>
                    {mode === "fuse" && currentLength > 1 && (
                        <div className={`${style.defaultBox} ${disabledStatus ? style.disabled : ""}`}>
                            {DefaultWidth[currentDefaultWeight]}
                            <div className={style.widthHoverBox} onClick={handlerDefault}>
                                <DecreasingWidthBoxes />
                                <AverageWidthBoxes />
                                <PrimaryWidthBoxes />
                            </div>
                        </div>
                    )}
                </div>
            )}
            <div
                onMouseEnter={setSelectorHover.bind(null,true)}
                onMouseLeave={setSelectorHover.bind(null,false)}
                className={`${style.controlerWrapper} ${disabled ? style.disabled : 'p-0'}`}>
                <div
                    className={style.controlerBox}
                    ref={controlerBoxRef}
                >
                    {colorArr.slice(0, currentLength).map((item, index, arr) => (
                        <div
                            key={item}
                            ref={controlerItemRefs[index]}
                            style={{
                                borderRadius: index === 0 ? pointerArr.length >= 3 ? '6px 0px 0px 6px' : '6px' : index === arr.length - 1 ? '0px 6px 6px 0px' : '',
                                width: `${pointerArr[index + 1] - pointerArr[index]}px`,
                                background: `${item}`,
                                left: `${pointerArr[index]}px`,
                                // right: index === pointerArr - 2 ? '7px' : '',
                            }}
                            className={`group flex relative ${disabled  ? style.disabled : 'h-full'} ${!disabled && currentIndex === index ? style.controlerSelect : ''} ${style.controlerDiv}`}
                            onClick={!disabled ? handlerClickWeight.bind(null, index) : undefined}
                            onMouseEnter={()=>{
                                // if(localStorage.getItem('directionExp')){
                                //     setCurrentWeight(false)
                                // }else{
                                //     setCurrentWeight(index)
                                // }
                                if(!weightsTipInit){
                                    if(weightTipRef.current){
                                        clearInterval(weightTipRef.current)
                                    }
                                    setWeightTipIndex(false)
                                }
                                
                            }}
                            onMouseLeave={()=>{
                                if(!weightsTipInit){
                                    setWeightTipIndex(true)
                                }
                            }}
                        >
                            {!(disabled) && <div className={`h-full w-full flex items-center absolute pointer-events-none overflow-hidden`}>
                                <img src={uploadImgBlob[index]?.data} alt="" className="h-auto w-[60px] min-w-[60px] scale-[140%]  opacity-[40%] z-[1] absolute right-[5%] rounded-lg" />
                                <div className={`absolute flex justify-center items-center left-[20px] h-[70%] aspect-square rounded-full bg-[rgba(255,255,255,0.25)] ${weightTipIndex===index ? 'animate-weight-selectorout':'opacity-0 invisible'}`}>
                                    <div className={`absolute h-[65%] aspect-square rounded-full bg-[rgba(255,255,255,0.4)] ${weightTipIndex===index ? 'animate-weight-selectorin':'opacity-0 invisible'}`}></div>
                                </div>
                            </div>}
                            {!(disabled || mode === "concat") && 
                                <>
                                    <span
                                        className={`group/control px-[1%] ${style.leftControler}`}
                                        style={index === 0 ? { display: 'none' } : {}}
                                        ref={leftControler}
                                        onMouseDown={handlerLeftMouseDown}
                                        onMouseEnter={()=>{setCurrentIndex(index)}}
                                    >
                                        <span />
                                        <span />
                                        <div className='absolute h-[100%] [transition:opacity_0.3s_ease] -left-[120%] text-white opacity-0 group-hover/control:opacity-100'><IoMdArrowDropleft className="h-full w-full"/></div>
                                        <div className='absolute h-[100%] [transition:opacity_0.3s_ease] -right-[120%] text-white opacity-0 group-hover/control:opacity-100'><IoMdArrowDropright className="h-full w-full"/></div>
                                    </span>
                                    {/* <span
                                        className={style.rightControler}
                                        ref={rightControler}
                                        onMouseDown={handlerRightMouseDown}
                                        style={index === arr.length - 1 ? { display: 'none' } : {}}
                                    >
                                        <span />
                                        <span />
                                    </span> */}
                                </>
                            }
                            {(mode === "concat" || mode === "fuse") && !disabled ? (
                                // TODO: set the x position based on weight center instead of hardcoding
                                <div className={`absolute ${index === dragging ? 'opacity-100 visible' : 'opacity-0 invisible'} ${style.directionHoverContainer} [transition:all_0.15s_ease]  group-hover:opacity-100 group-hover:visible -translate-y-full`}
                                    style={{ transform: `translateX(${currentLength !== 1 ? `${-19 * index - 12}px` : '70%'}) translateY(-100%)` }}>
                                    <div
                                        className="absolute top-0.5 left-1/2 transform -translate-x-1/2 flex">
                                        <DirectionSelector imagedoms={imagedoms} images={presetDirections} directions={directions} setWeightsTipInit={setWeightsTipInit} setDraggingGlobal={setDragging} imageIndex={index} setSelection={setSelectedDirection} textColor={textColorArr[index]} direction={selectedDirection} />
                                        <div className="w-20 h-20 p-2 mt-1.5 bg-white rounded-lg ml-2"
                                            style={{ backgroundColor: hoverColorArr[index] }}>
                                            <img src={uploadImgBlob[index]?.data} alt=""
                                                className="w-full h-full object-contain rounded-lg" />
                                        </div>
                                        <span className={`${style.arrow} bg-white `}></span>
                                        <span className={`absolute bottom-[-18px] block w-full h-full bg-transparent z-10`}></span>
                                    </div>
                                </div>
                            ) : (
                                <div className={style.weightHoverImgWrapper}
                                    style={{ backgroundColor: hoverColorArr[index] }}>
                                    {uploadImgBlob.length && <img src={uploadImgBlob[index]?.data} alt="" />}
                                    <span className={style.arrow}
                                        style={{ backgroundColor: hoverColorArr[index] }}></span>
                                </div>
                            )}
                        </div>
                    ))}
                </div>

            </div>
        </div>
    )

}

const DecreasingWidthBoxes = ({ parentWidth = 300 }) => {
    const numBoxes = 5;
    // Calculate the width of each box based on the parent width
    // const totalSpacing = (numBoxes - 1) * spacing;
    const maxBoxWidth = parentWidth / numBoxes;
    const minBoxWidth = maxBoxWidth / numBoxes;
    const boxWidths = Array.from({ length: numBoxes }, (_, i) => maxBoxWidth - (i * (maxBoxWidth - minBoxWidth) / (numBoxes - 1)));

    return (
        <div className={style.decreasingWrapper} data-index='1' data-name='widthBox'>
            {boxWidths.map((width, index) => (
                <div
                    key={index}
                    className={style.decreasingItem}
                    style={{ width: width }}
                />
            ))}
        </div>
    );
};

const AverageWidthBoxes = () => {

    return (
        <div className={style.decreasingWrapper} data-index='0' data-name='widthBox'>
            {new Array(5).fill(1).map((width, index) => (
                <div
                    key={index}
                    className={style.decreasingItem}
                    style={{ width: '20%' }}
                />
            ))}
        </div>
    );
};

const PrimaryWidthBoxes = () => {
    const boxWidths = ['50%', '12.5%', '12.5%', '12.5%', '12.5%',]

    return (
        <div className={style.decreasingWrapper} data-index='2' data-name='widthBox'>
            {boxWidths.map((width, index) => (
                <div
                    key={index}
                    className={style.decreasingItem}
                    style={{ width: width }}
                />
            ))}
        </div>
    );
};

export { WeightSelector }